import { Number, PositiveNumber, PositiveIntegerNumber, IntegerNumber } from './components/Number';
import { RooneyInteger, RooneyPositive, RooneyPositiveInteger } from './components/RooneyNumber';
import {
  Popover,
  PopoverInteger,
  PopoverPositive,
  PopoverPositiveInteger,
} from './components/PopoverNumber';
import Time from './components/Time';
import Date from './components/Date';
import DateTime from './components/DateTime';
import Calendar from './components/CalendarDate';
import Appointment from './components/CalendarAppointment';

export default {
  Number,
  PositiveNumber,
  PositiveIntegerNumber,
  IntegerNumber,
  Time,
  DateTime,
  Date,
  Calendar,
  Appointment,
  RooneyInteger,
  RooneyPositive,
  RooneyPositiveInteger,
  Popover,
  PopoverInteger,
  PopoverPositive,
  PopoverPositiveInteger,
};
